import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.page.html',
  styleUrls: ['./access-denied.page.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class AccessDeniedPage {
  private router = inject(Router);

  goBack() {
    this.router.navigate(['/login']);
  }
}
